import { Box } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import { isMobile } from 'react-device-detect';

// caller must give the immediate parent `position: relative` (and `className="fullscreen"` if it wants the existing `.fullscreen:hover .nav-arrow` CSS fade-in from styles.css)
const buttonSx = {
    position: 'absolute', top: '50%', transform: 'translateY(-50%)',
    width: 40, height: 40, borderRadius: '50%',
    bgcolor: 'rgba(43, 51, 63, 0.7)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    cursor: 'pointer', zIndex: 2,
    '&:hover': { bgcolor: 'rgba(43, 51, 63, 0.9)' }
}

const fadeSx = isMobile ? {} : { opacity: 0, transition: '0.5s ease' }
const arrowClassName = isMobile ? "" : "nav-arrow"
const stopDoubleClick = e => e.stopPropagation() // defensive: caller's image wrapper typically has own onDoubleClick

export default function NavArrows({ hasPrev, hasNext, onPrev, onNext }) {
    return (
        <>
            {hasPrev && (
                <Box
                    className={arrowClassName}
                    onClick={onPrev}
                    onDoubleClick={stopDoubleClick}
                    sx={{ ...buttonSx, left: 8, ...fadeSx }}
                >
                    <ArrowBackIos sx={{ color: 'white', fontSize: 18, ml: '4px' }} />
                </Box>
            )}
            {hasNext && (
                <Box
                    className={arrowClassName}
                    onClick={onNext}
                    onDoubleClick={stopDoubleClick}
                    sx={{ ...buttonSx, right: 8, ...fadeSx }}
                >
                    <ArrowForwardIos sx={{ color: 'white', fontSize: 18 }} />
                </Box>
            )}
        </>
    )
}
